<template>
  <div class="pb-100 ">
    <div class="container"> 
      <div class="section-title mw-600">
        <span class="top-title">Our Celebrities</span>
        <h2>Exclusively shining with us — only on MyCelebrity.</h2>
      </div>

      <swiper
        :spaceBetween="25"
        :slidesPerView="1"
        :preventClicks="true"
        :loop="true"
        :autoplay="{
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }"
        :navigation="{
          nextEl: '.next',
          prevEl: '.prev',
        }"
        :modules="modules"
        class="testimonial-slide testimonials-wrappers"
      >
        <swiper-slide v-for="testimonial in testimonials" :key="testimonial.id">
          <div class="row align-items-center">
            <div class="col-lg-4">
              <div
                class="testimonial-img position-relative mb-4 mb-lg-0 d-inline-block"
              >
                <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" :src="testimonial.image" alt="testimonials" />
                
              </div>
            </div>
            <div class="col-lg-8">
              <div class="testimonial-quot">
                <p>{{ testimonial.description }}</p>
<div class="testimonial-info ms-0 text-start">
             <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">{{ testimonial.name }}</h3>
                  <span>{{ testimonial.designation }}</span> 
                </div>
               
              </div>
            </div>
          </div>
        </swiper-slide>

       
      </swiper>
    </div>

   <div class="button-row">
      <router-link to="/get-your-wish" class="btn btn-primary get-wish-btn">
        Get your Wish
      </router-link>
      <router-link to="/business-enquiry" class="btn btn-primary get-wish-btn">
        Business Enquiry
      </router-link>
    </div>
  </div>
</template>
  
<script lang="ts">
import { defineComponent } from "vue";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";

export default defineComponent({
  name: "TestimonialsContent",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      testimonials: [
        {
          id: 1,
          image: require("../../assets/images/paro.jpg"),
          description:
            "Parvati Nair is an acclaimed Indian actress and model, born in Abu Dhabi in December 1992. Initially a software engineer, she shifted to modeling at age 15, winning titles like Miss Karnataka and Miss Navy Queen. She began her acting career with the Malayalam film Poppins in 2012 and gained recognition in Kannada with Story Kathe, for which she won the SIIMA Best Debut award. She went on to star in popular South Indian films like Yennai Arindhaal, Uttama Villain, and the sci-fi hit GOAT (2024), and also appeared in Bollywood’s 83 as Sunil Gavaskar’s wife. Beyond films, she is active in fashion and charity, and married entrepreneur Aashrith Ashok in February 2025.",
          name: "Parvati Nair",
        designation: "Celebrity",
        },
       
      ],
    };
  },
  setup() {
    return {
      Autoplay,
      modules: [Navigation],
    };
  },
});
</script>

<style lang="scss" scoped>
.pb-100 {
  padding-top: 100px;
}
.testimonials-wrappers {
  max-width: 1096px;
  margin: auto;
}
.testimonial-quot {
  margin-left: 64px;
  p {
    font-weight: 500;
    line-height: 30px;
    font-size: 18px;
    color: #4c4c4c;
    font-style: italic;
    margin-bottom: 40px;
  }
}
.button-row {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-right: 170px;
  margin-top: -44px;
}
@media (max-width: 767px) {
  .button-row {
    flex-direction: column;
    align-items: stretch;
    margin-right: 0;
    margin-top: 16px;
    gap: 12px;
  }
}
.get-wish-btn {
    font-size: 18px;
    padding: 12px 32px;
    border-radius: 30px;
    background: #ff5a5f;
    color: #fff;
    border: none;
    transition: background 0.2s;
    margin-top: 32px;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(255,90,95,0.15);
    letter-spacing: 1px;
    text-transform: uppercase;
  }
  .get-wish-btn:hover {
    background: #e14b50;
    color: #fff;
    box-shadow: 0 4px 16px rgba(255,90,95,0.18);
  }

.testimonial-img {
  .top-0 {
    top: 50px !important;
  }
  .end {
    right: -10px !important;
  }
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .testimonial-quot {
    margin-left: 0;
  }
}
/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .testimonial-quot {
    margin-left: 0;
  }
}
</style>